t = require('app/scripts/views/internal/teacup-with-helpers')('observer_list')

module.exports = ->
  t.ul { class: 'pop-over-member-list js-list ' + t.mustacheBlock('__ed', (-> 'js-list-draggable-board-members')) }
